import {
    CONVERT_DIRECT_BILL_ENTRY_TO_BE_FAILURE,
    CONVERT_DIRECT_BILL_ENTRY_TO_BE_REQUEST,
    CONVERT_DIRECT_BILL_ENTRY_TO_BE_SUCCESS,
    CREATE_DIRECT_BILLING_FAILURE,
    CREATE_DIRECT_BILLING_MASTER_USERFORM,
    CREATE_DIRECT_BILLING_REQUEST,
    CREATE_DIRECT_BILLING_SUCCESS,
    DELETE_DIRECT_BILLING_DATA_FAILURE,
    DELETE_DIRECT_BILLING_DATA_REQUEST,
    DELETE_DIRECT_BILLING_DATA_SUCCESS,
    DIRECT_BILLING_NAVIGATE_TO_DETAIL_REVERSE,
    DIRECT_BILLING_NAVIGATE_TO_DETAIL_TAB,
    DIRECT_BILLING_RESET_USERFORM,
    FETCH_ALL_DIRECT_BILLING_DATA_FAILURE,
    FETCH_ALL_DIRECT_BILLING_DATA_REQUEST,
    FETCH_ALL_DIRECT_BILLING_DATA_SUCCESS,
    FETCH_DIRECT_BILLING_BRN_NO_FAILURE,
    FETCH_DIRECT_BILLING_BRN_NO_REQUEST,
    FETCH_DIRECT_BILLING_BRN_NO_SUCCESS,
    FETCH_DIRECT_BILLING_DATA_BY_ID_FAILURE,
    FETCH_DIRECT_BILLING_DATA_BY_ID_REQUEST,
    FETCH_DIRECT_BILLING_DATA_BY_ID_SUCCESS,
    FETCH_DIRECT_BILLING_PROGRAM_ID_FAILURE,
    FETCH_DIRECT_BILLING_PROGRAM_ID_REQUEST,
    FETCH_DIRECT_BILLING_PROGRAM_ID_SUCCESS,
    HEADER_SEARCH_CALL_ONLOAD,
    NAVIGATE_DIRECT_BILLING,
    NAVIGATE_DIRECT_BILLING_DETAILS,
    UPDATE_DIRECT_BILLING_FAILURE,
    UPDATE_DIRECT_BILLING_REQUEST,
    UPDATE_DIRECT_BILLING_SUCCESS

} from "./directBilling.actionType";


export const DIRECT_BILLING = 'directBilling';

let initialState = {
    loading: false,
    DirectBillingAllData: [],
    userform: {
        startDate: new Date().setDate(new Date().getDate() - 15),
        endDate: new Date(),
        unitId: 1,
        fldIsWages: false,
        fldIsStylePreparation: false
    },
    selectedRow: {},
    detailsId: '',
    activeKey: 1,
    DeleteFormData: '',
    gridPageIndex: 0,
    isDirectBilling: false,
    DirectBillingSelectedValue: {},
    DirectBillingInvoiceDataV2: [],
    headerSearchCall: true,
    convertToBillEntry: '',
    directBillingBrlNo: '',
    programId: []
};

export let directBillingReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_ALL_DIRECT_BILLING_DATA_REQUEST:
        case FETCH_DIRECT_BILLING_DATA_BY_ID_REQUEST:
        case CREATE_DIRECT_BILLING_REQUEST:
        case UPDATE_DIRECT_BILLING_REQUEST:
        case DELETE_DIRECT_BILLING_DATA_REQUEST:
        case CONVERT_DIRECT_BILL_ENTRY_TO_BE_REQUEST:
        case FETCH_DIRECT_BILLING_BRN_NO_REQUEST:
        case FETCH_DIRECT_BILLING_PROGRAM_ID_REQUEST:
            return {
                ...state,
                loading: true
            };
        case HEADER_SEARCH_CALL_ONLOAD:
            return {
                ...state,
                loading: false,
                headerSearchCall: payload
            }
        case CREATE_DIRECT_BILLING_MASTER_USERFORM:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                },
                headerFields: {
                    ...state.headerFields,
                    [payload.key]: payload.value
                }
            };
        case FETCH_ALL_DIRECT_BILLING_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                DirectBillingAllData: updatePayload
            };
        case FETCH_DIRECT_BILLING_DATA_BY_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    ...updatePayload,
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId,

                }
            }
        case CREATE_DIRECT_BILLING_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                },
                detailsId: updatePayload
            }
        case UPDATE_DIRECT_BILLING_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                },
                detailsId: ''
            }
        case DELETE_DIRECT_BILLING_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                },
                detailsId: ''
            }
        case CONVERT_DIRECT_BILL_ENTRY_TO_BE_SUCCESS:
            return {
                ...state,
                loading: false,
                convertToBillEntry: updatePayload
            }
        case FETCH_DIRECT_BILLING_BRN_NO_SUCCESS:
            return {
                ...state,
                loading: false,
                directBillingBrlNo: updatePayload
            };
        case DIRECT_BILLING_RESET_USERFORM:
            return {
                ...state,
                loading: false,
                userform: {
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId,
                    //fldIsStylePreparation: state.userform.fldIsStylePreparation
                },
                detailsId: '',
                activeKey: 1,
                directBillingBrlNo: '',
            }
        case NAVIGATE_DIRECT_BILLING:
            return {
                ...state,
                isDirectBilling: false
            };
        case NAVIGATE_DIRECT_BILLING_DETAILS:
            return {
                ...state,
                isDirectBilling: true,
                loading: false,
                DirectBillingSelectedValue: updatePayload.DirectBillingSelectedValue
            };

        case DIRECT_BILLING_NAVIGATE_TO_DETAIL_TAB:
            return {
                ...state,
                userform: {
                    ...updatePayload,
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                },
                activeKey: 2
            };
        case DIRECT_BILLING_NAVIGATE_TO_DETAIL_REVERSE:
            return {
                ...state,
                userform: {
                    ...updatePayload,
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                },
                DirectBillingSelectedValue: {},
                detailsId: '',
                activeKey: 1
            };
        case FETCH_DIRECT_BILLING_PROGRAM_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                programId: updatePayload
            };
        case FETCH_ALL_DIRECT_BILLING_DATA_FAILURE:
        case FETCH_DIRECT_BILLING_DATA_BY_ID_FAILURE:
        case CREATE_DIRECT_BILLING_FAILURE:
        case UPDATE_DIRECT_BILLING_FAILURE:
        case DELETE_DIRECT_BILLING_DATA_FAILURE:
        case CONVERT_DIRECT_BILL_ENTRY_TO_BE_FAILURE:
        case FETCH_DIRECT_BILLING_PROGRAM_ID_FAILURE:
            return {
                ...state,
                loading: false
            };
        case FETCH_DIRECT_BILLING_BRN_NO_FAILURE:
            return {
                ...state,
                loading: false,
                directBillingBrlNo: updatePayload
            };
        default:
            return state

    }
}